import React, {useState} from 'react'
import gql from 'graphql-tag'
import moment from 'lib/localizedMoment'
import Query from 'components/shared/Query'
import WeekNumberPicker from 'shared/components/WeekNumberPicker'
import {momentRange} from 'shared/lib/dateHelpers'
import ResourceAvailabilityForDates from 'components/shared/ResourceAvailabilityForDates'
import './index.scss'

const resourceAvailabilityQuery = gql`
  query ResourceAvailabilityQuery(
    $webOrderId: ID!,
    $serviceProviderIds: [ID]!
    $dates: [Date]!,
  ) {
    webOrder(id: $webOrderId) {
      id
      serviceProviderAvailability(dates: $dates, serviceProviderIds: $serviceProviderIds) {
        date
        isAvailable
        unavailabilityReason
        serviceProvider {
          ...ServiceProviderProperties
        }
        pendingBookings {
          ...ResourceAvailabilityPendingBookingProperties
        }
      }
    }
  }

  fragment ResourceAvailabilityPendingBookingProperties on PendingBooking {
    id
    startsAt
    endsAt
    bookingFee
    serviceProvider {
      ...ServiceProviderProperties
    }
  }

  fragment ServiceProviderProperties on ServiceProvider {
    id
    name
  }
`

function getLookupVariables({ week, year }) {
  const selectedWeek = moment().year(year).isoWeek(week)

  return {
    from: selectedWeek.clone().startOf('week'),
    to: selectedWeek.clone().endOf('week'),
  }
}

const WeeklyAvailability = ({webOrder, serviceProvider, reservedBooking, selectedBooking, onSelect, onRemove}) => {
  const now = moment()
  const [{week, year}, setOptions] = useState({
    week: now.isoWeek(),
    year: now.year(),
  })

  const {from, to} = getLookupVariables({week, year})
  const range = momentRange(from, to)

  return (
    <div className="weekly-availability">
      <WeekNumberPicker
        week={week}
        year={year}
        onChange={(week, year) => setOptions({week, year})}
      />
      <Query
        inlineLoading
        inlineError
        notifyOnNetworkStatusChange
        fetchPolicy="network-only"
        query={resourceAvailabilityQuery}
        variables={{
          webOrderId: webOrder.id,
          dates: range.map(d => moment(d).format('YYYY-MM-DD')),
          serviceProviderIds: [serviceProvider.id],
        }}
      >
        {({getData}) => {
          const availabilities = getData('webOrder.serviceProviderAvailability', [])
          return (
            <ResourceAvailabilityForDates
              availabilities={availabilities}
              dates={range}
              reservedBooking={reservedBooking}
              selectedBooking={selectedBooking}
              onSelect={onSelect}
              onRemove={onRemove}
            />
          )
        }}
      </Query>
    </div>
  )
}

export default WeeklyAvailability
